var $92ef254c82a5c769$exports = {};
$92ef254c82a5c769$exports = {
  "Clear search": "\u05E0\u05E7\u05D4 \u05D7\u05D9\u05E4\u05D5\u05E9"
};
export { $92ef254c82a5c769$exports as default };